import { matchPath } from 'react-router-dom';

import {
  isCorrelationRulesRoute,
  isFullBleedAIRoute,
  isSimpleDetectionFormRoute,
  isWorkbenchRoute,
} from 'Components/Layout/utils';
import useRouter from 'Hooks/useRouter';
import { activeDashboardUrls } from 'Pages/Dashboard/Routes';
import urls from 'Source/urls';
import useCustomDashboardsEnabled from 'Hooks/useCustomDashboardsEnabled';

const isDashboardRoute = (pathname: string, enableCustomDashboards: boolean): boolean => {
  const isCustomDashboardRoute =
    matchPath(pathname, urls.dashboard.customDashboard(':id')) !== null;

  return (
    activeDashboardUrls.includes(pathname) || (enableCustomDashboards && isCustomDashboardRoute)
  );
};

export const useGetPageHasHeader = (): boolean => {
  const pageURL = window.location.href;
  const { history } = useRouter();

  const enableCustomDashboards = useCustomDashboardsEnabled();

  // Don't show header for correlation rules, dashboard pages, full-bleed AI pages, or the
  // workbench. (The Scheduled Prompts list is not full-bleed, so it keeps the shared header.)
  const { pathname } = history.location;
  return !(
    isCorrelationRulesRoute(pageURL) ||
    isSimpleDetectionFormRoute(pageURL) ||
    isDashboardRoute(pathname, enableCustomDashboards) ||
    isFullBleedAIRoute(pathname) ||
    isWorkbenchRoute(pageURL)
  );
};
